<script>
import BaseLineItem from './../../TableList/LineItem.vue'
export default {
  extends: BaseLineItem,
  methods: {
    handleLineItemClick() {
      this.handlePreviewClick()
    }
  }
}
</script>
